import React, { useState } from "react";
import Icon from "../Icon";
import { pickFiles } from "../../lib/files";

/**
 * Drag-and-drop + browse area. `accept` is a MIME/extension filter used both for the
 * file dialog and to filter dropped files. onFiles(File[]) gets only matching files.
 */
export default function DropZone({ icon = "image", accept = "image/*", multiple = true, disabled = false, label, hint, onFiles, testId }) {
  const [over, setOver] = useState(false);
  const matches = (f) => (accept === "image/*" ? /^image\//.test(f.type) : /pdf/i.test(f.type) || /\.pdf$/i.test(f.name));

  const browse = async () => {
    if (disabled) return;
    const files = await pickFiles({ accept, multiple });
    if (files.length) onFiles(files);
  };
  const onDrop = (e) => {
    e.preventDefault();
    setOver(false);
    if (disabled) return;
    const files = Array.from(e.dataTransfer?.files || []).filter(matches);
    if (files.length) onFiles(multiple ? files : files.slice(0, 1));
  };

  return (
    <div
      className={`dz${over ? " over" : ""}`}
      onDragOver={(e) => { e.preventDefault(); if (!disabled) setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={onDrop}
    >
      <Icon name={icon} size={22} />
      <div><b>{label}</b> or <button type="button" className="link" onClick={browse} disabled={disabled} data-testid={testId ? `${testId}.browse` : undefined}>browse</button></div>
      {hint && <span className="meta">{hint}</span>}
    </div>
  );
}
